var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { ManifestResource } from "./internal";

var AnnotationPage =
/** @class */
function (_super) {
  __extends(AnnotationPage, _super);

  function AnnotationPage(jsonld, options) {
    return _super.call(this, jsonld, options) || this;
  }

  AnnotationPage.prototype.getItems = function () {
    return this.getProperty("items");
  };

  return AnnotationPage;
}(ManifestResource);

export { AnnotationPage };